import { POS_TYPE, POS_TYPE_NAME } from '../../constants';

function getPOSModelName (pos, lowercase, plural) {
	let name = '';

	if (pos.type === POS_TYPE.MARKET) {
		name = lowercase ? POS_TYPE_NAME[pos.type].toLowerCase() : POS_TYPE_NAME[pos.type];
	}
	else {
		name = lowercase ? POS_TYPE_NAME[POS_TYPE.MACHINE].toLowerCase() : POS_TYPE_NAME[POS_TYPE.MACHINE];
	}

	return plural ? `${name}s` : name;
}

export default getPOSModelName;
